<template>
  <el-container class="app-container">
    <navigation />
    <el-container class="app-container__body">
      <app-header class="app-container__header"/>
      <transition name="moveInRight" mode="out-in">
        <router-view></router-view>
      </transition>
    </el-container>
  </el-container>
</template>

<script>
/*Main view wrapper*/

// actions
import { GET_FEEDS } from "../../store/actions/feeds";

// components
import Navigation from "../../components/Navigation";
import AppHeader from "../../components/AppHeader";

// store
import {TOGGLE_HOME_PAGE} from "../../store/actions/common";

export default {
  name: "Main",
  components: {
    AppHeader,
    Navigation
  },
  watch: {
    $route(route) {
      let home = route.name === 'home';
      this.$store.dispatch(TOGGLE_HOME_PAGE, home);
    }
  },
  mounted() {
    this.$store.dispatch(GET_FEEDS);
  },
  destroyed() {
    console.info("TODO: need to destroy all data in the store, when Main layout is destroyed");
  }
}
</script>

<style>
  @import "../../style/animations.css";
  @import "../../style/main.css";
</style>

